var _defs, _sodipodiNamedview;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModuleAlarm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 3333.3333,
    height: 3333.3333,
    viewBox: "0 0 3333.3333 3333.3333",
    sodipodiDocname: "alarm_module.ai",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,2500 H 2500 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "alarm_module",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,3333.3333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(402,1509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-468.338 379.663,-848 848,-848 468.338,0 848,379.662 848,848 0,468.338 -379.662,848 -848,848 C 379.663,848 0,468.338 0,0",
    style: {
      fill: "#fdbb3b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(402,1509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-468.338 379.663,-848 848,-848 468.338,0 848,379.662 848,848 0,468.338 -379.662,848 -848,848 C 379.663,848 0,468.338 0,0 Z",
    style: {
      fill: "none",
      stroke: "#fdbb3b",
      strokeWidth: 60,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(1218.4418,1191.1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 115.323,17.609 c 4.096,0.625 7.171,4.903 7.171,9.976 v 73.721 c 0,5.073 -3.075,9.351 -7.171,9.977 L 0,128.891 c -4.88,0.745 -9.187,-3.932 -9.187,-9.976 V 9.976 C -9.187,3.933 -4.88,-0.745 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(1198.2163,1381.9468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 77.024,87.618 c 2.736,3.111 2.341,8.365 -0.92,12.251 l -47.386,56.474 c -3.261,3.886 -8.367,5.186 -11.906,3.033 L -82.85,98.736 c -4.217,-2.565 -4.51,-8.918 -0.625,-13.547 L -13.451,1.737 C -9.566,-2.893 -3.259,-3.707 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(1060.0499,1515.1418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 2.684,116.629 c 0.096,4.142 -3.583,7.913 -8.579,8.794 l -72.601,12.802 c -4.996,0.881 -9.743,-1.405 -11.07,-5.33 L -126.933,22.382 c -1.581,-4.676 2.277,-9.731 8.229,-10.78 L -11.42,-7.315 C -5.468,-8.365 -0.114,-4.935 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(868.5922,1528.3635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -72.911,91.069 c -2.59,3.234 -7.832,3.758 -12.225,1.221 l -63.845,-36.86 c -4.393,-2.537 -6.561,-7.339 -5.054,-11.198 l 42.412,-108.678 c 1.794,-4.598 7.999,-5.99 13.233,-2.968 l 94.344,54.47 C 1.188,-9.923 3.085,-3.853 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(713.4283,1415.4253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -114.391,22.896 c -4.063,0.813 -8.415,-2.155 -10.15,-6.922 l -25.214,-69.275 c -1.736,-4.767 -0.309,-9.839 3.326,-11.827 l 102.346,-55.99 c 4.33,-2.369 9.978,0.553 12.045,6.233 L 5.221,-12.517 C 7.288,-6.838 4.84,-0.969 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(667.1612,1229.1722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -102.346,-55.99 c -3.635,-1.988 -5.061,-7.06 -3.326,-11.827 l 25.214,-69.275 c 1.735,-4.767 6.088,-7.736 10.15,-6.922 l 114.391,22.896 c 4.841,0.969 7.288,6.837 5.221,12.517 L 12.045,-6.233 C 9.978,-0.553 4.33,2.369 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g50",
    transform: "translate(751.4397,1056.754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -42.412,-108.677 c -1.506,-3.86 0.661,-8.662 5.054,-11.198 l 63.845,-36.861 c 4.393,-2.536 9.635,-2.013 12.225,1.222 l 72.911,91.068 c 3.085,3.854 1.188,9.923 -4.046,12.945 L 13.233,2.968 C 7.999,5.99 1.795,4.598 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "translate(926.829,978.8474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 37.367,-110.514 c 1.327,-3.925 6.074,-6.21 11.07,-5.329 l 72.601,12.801 c 4.996,0.881 8.675,4.652 8.58,8.795 l -2.685,116.629 c -0.113,4.935 -5.468,8.364 -11.42,7.315 L 8.23,10.78 C 2.278,9.73 -1.581,4.676 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g58",
    transform: "translate(1111.2626,1031.9054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 99.661,-60.639 c 3.54,-2.154 8.645,-0.853 11.906,3.033 l 47.387,56.473 c 3.261,3.886 3.655,9.14 0.92,12.252 L 82.85,98.736 c -3.259,3.708 -9.566,2.893 -13.451,-1.737 L -0.625,13.548 C -4.51,8.918 -4.217,2.566 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62",
    transform: "translate(1218.4418,1191.1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 115.323,17.609 c 4.096,0.625 7.171,4.903 7.171,9.976 v 73.721 c 0,5.073 -3.075,9.351 -7.171,9.977 L 0,128.891 c -4.88,0.745 -9.187,-3.932 -9.187,-9.976 V 9.976 C -9.187,3.933 -4.88,-0.745 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(1233.9595,1258.1854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-156.36 -126.755,-283.115 -283.115,-283.115 -156.36,0 -283.114,126.755 -283.114,283.115 0,156.36 126.754,283.115 283.114,283.115 C -126.755,283.115 0,156.36 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "translate(1124.6641,1258.1854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-95.998 -77.822,-173.819 -173.819,-173.819 -95.998,0 -173.819,77.821 -173.819,173.819 0,95.998 77.821,173.819 173.819,173.819 C -77.822,173.819 0,95.998 0,0",
    style: {
      fill: "#006b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74",
    transform: "translate(1793.9927,1668.0449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 115.323,17.609 c 4.096,0.625 7.171,4.903 7.171,9.976 v 73.721 c 0,5.073 -3.075,9.351 -7.171,9.977 L 0,128.891 c -4.88,0.745 -9.187,-3.932 -9.187,-9.976 V 9.976 C -9.187,3.933 -4.88,-0.745 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g78",
    transform: "translate(1773.7672,1858.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 77.024,87.617 c 2.736,3.112 2.341,8.366 -0.919,12.252 l -47.387,56.474 c -3.261,3.886 -8.367,5.186 -11.906,3.033 L -82.85,98.736 c -4.217,-2.565 -4.51,-8.918 -0.625,-13.547 L -13.45,1.737 C -9.566,-2.893 -3.259,-3.707 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g82",
    transform: "translate(1635.6008,1992.0851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 2.685,116.629 c 0.095,4.142 -3.584,7.913 -8.58,8.794 l -72.601,12.802 c -4.996,0.881 -9.743,-1.405 -11.07,-5.33 L -126.933,22.382 c -1.581,-4.676 2.277,-9.731 8.23,-10.78 L -11.42,-7.315 C -5.468,-8.365 -0.114,-4.935 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86",
    transform: "translate(1444.1432,2005.3068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -72.911,91.069 c -2.59,3.234 -7.832,3.758 -12.225,1.221 l -63.845,-36.86 c -4.393,-2.537 -6.561,-7.339 -5.054,-11.198 l 42.412,-108.678 c 1.794,-4.598 7.999,-5.99 13.233,-2.968 l 94.344,54.469 C 1.188,-9.923 3.085,-3.853 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90",
    transform: "translate(1288.9792,1892.3685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -114.391,22.896 c -4.063,0.813 -8.415,-2.155 -10.15,-6.922 l -25.214,-69.275 c -1.735,-4.767 -0.309,-9.839 3.326,-11.828 l 102.346,-55.989 c 4.33,-2.369 9.978,0.553 12.045,6.232 L 5.221,-12.517 C 7.288,-6.838 4.84,-0.969 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g94",
    transform: "translate(1242.7122,1706.1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -102.346,-55.99 c -3.635,-1.988 -5.061,-7.06 -3.326,-11.827 l 25.214,-69.275 c 1.735,-4.767 6.088,-7.736 10.15,-6.922 l 114.391,22.896 c 4.84,0.969 7.288,6.837 5.221,12.517 L 12.045,-6.233 C 9.978,-0.553 4.33,2.369 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g98",
    transform: "translate(1326.9907,1533.6973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -42.412,-108.677 c -1.506,-3.86 0.661,-8.662 5.054,-11.199 l 63.845,-36.86 c 4.393,-2.537 9.635,-2.013 12.225,1.222 l 72.911,91.068 c 3.085,3.854 1.188,9.923 -4.046,12.945 L 13.233,2.968 C 7.999,5.99 1.795,4.598 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g102",
    transform: "translate(1502.38,1455.7905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 37.367,-110.514 c 1.327,-3.925 6.074,-6.21 11.07,-5.329 l 72.601,12.801 c 4.996,0.881 8.675,4.652 8.58,8.795 l -2.685,116.629 c -0.113,4.935 -5.468,8.364 -11.42,7.315 L 8.229,10.78 C 2.277,9.73 -1.581,4.676 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g106",
    transform: "translate(1686.8135,1508.8485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 99.662,-60.639 c 3.539,-2.154 8.645,-0.853 11.905,3.033 l 47.387,56.473 c 3.261,3.886 3.655,9.14 0.92,12.252 L 82.85,98.736 C 79.591,102.444 73.284,101.629 69.399,97 L -0.625,13.548 C -4.51,8.918 -4.217,2.566 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g110",
    transform: "translate(1793.9927,1668.0449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 115.323,17.609 c 4.096,0.625 7.171,4.903 7.171,9.976 v 73.721 c 0,5.073 -3.075,9.351 -7.171,9.977 L 0,128.891 c -4.88,0.745 -9.187,-3.932 -9.187,-9.976 V 9.976 C -9.187,3.933 -4.88,-0.745 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g114",
    transform: "translate(1809.5105,1735.1287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-156.36 -126.755,-283.115 -283.115,-283.115 -156.36,0 -283.114,126.755 -283.114,283.115 0,156.36 126.754,283.115 283.114,283.115 C -126.755,283.115 0,156.36 0,0",
    style: {
      fill: "#00405a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g118",
    transform: "translate(1700.215,1735.1287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-95.998 -77.821,-173.819 -173.819,-173.819 -95.998,0 -173.819,77.821 -173.819,173.819 0,95.998 77.821,173.819 173.819,173.819 C -77.821,173.819 0,95.998 0,0",
    style: {
      fill: "#006b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleAlarm);
export default __webpack_public_path__ + "static/media/module-alarm.300fbc11ce5a8e339f634c544a037616.svg";
export { ForwardRef as ReactComponent };